import { createStore, applyMiddleware, combineReducers } from "redux";
import { thunk } from "redux-thunk";
import { reducerAddItem } from "../reducer/reducerPostData";
import { reducerGetNews, reducerGetProduct } from "../reducer/reducerGetData";

const rootReducer = combineReducers({
  item: reducerAddItem,
  news: reducerGetNews,
  product: reducerGetProduct,
});

const store = createStore(rootReducer, applyMiddleware(thunk));

export default store;
